/**
 * Created by andrey on 27.01.2021.
 */

const UnitLibraryIcon = cleverapps.Layout.extend({
    ctor: function (unit) {
        this.unit = unit;

        const styles = cleverapps.styles.UnitLibraryIcon;

        if (cleverapps.config.debugMode && cleverapps.flags.keyboardAnchorsMode) {
            delete unit.unknown;
        }

        this.background = new UnitLibraryIconBg(unit);

        if (styles.footer) {
            this.footer = new UnitLibraryIconFooter(unit, this.collectReward.bind(this));
        }

        this.addProducer();

        this._super([this.background, this.footer].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.UnitLibraryIcon.margin
        });

        cleverapps.eventBus.on("unitStatusChanged", this.onUpdateStatus.bind(this), this);

        this.onUpdateStatus();
    },

    addProducer: function () {
        if (cleverapps.unitsLibrary.isOpened(this.unit) || this.unit.unknown) {
            return;
        }

        const styles = cleverapps.styles.UnitLibraryIcon.producer;
        const producerData = Families[this.unit.code].units[this.unit.stage].producer;

        if (producerData && this.unit.stage > 0 && Families[this.unit.code].units[this.unit.stage - 1].unmergeable) {
            const producer = this.producer = UnitView.getUnitImage(producerData, { alignAnchorX: true, preferStatic: true });
            producer.pData = producerData;
            if (producer.clearTrack) {
                producer.clearTrack(0);
            }
            cleverapps.UI.fitToBox(producer, styles);
            producer.setAlignment(styles);
            this.background.addChild(producer);
        }
    },

    collectReward: function () {
        cleverapps.unitsLibrary.removeFresh(this.unit, this.background);
    },

    onUpdateStatus: function () {
        if (this.clickHandler) {
            this.clickHandler.remove();
            this.clickHandler = undefined;
        }

        this.background.updateStatus();
        this.footer && this.footer.updateStatus();

        if (cleverapps.unitsLibrary.isFresh(this.unit)) {
            this.clickHandler = cleverapps.UI.onClick(this, () => {
                this.collectReward();

                if (this.stageNumber) {
                    this.stageNumber
                        .runAction(new cc.DelayTime(0.4))
                        .setFinalize(() => {
                            this.stageNumber.setVisible(true);
                        });
                }
            }, {
                interactiveScale: false
            });
        }

        if (this.producer) {
            if (cleverapps.unitsLibrary.isOpened(this.unit)) {
                this.producer.removeFromParent();
                delete this.producer;
            } else {
                this.clickHandler = cleverapps.UI.onClick(this, () => {
                    const GuideClass = this.producer.pData.guide;
                    new GuideClass(this.producer.pData.guideOptions, this.producer.pData);
                }, {
                    interactiveScale: false
                });
            }
        }

        if (cleverapps.config.debugMode && !this.clickHandler) {
            this.clickHandler = cleverapps.UI.onClick(this, () => {}, {
                interactiveScale: false,
                onDoubleClick: function () {
                    if (cleverapps.unitsLibrary.isOpened(this.unit)) {
                        cleverapps.unitsLibrary.resetUnit(this.unit);
                    } else if (!cleverapps.unitsLibrary.isOpened(this.unit)) {
                        cleverapps.unitsLibrary.openUnit(this.unit);
                    }
                    cleverapps.focusManager.currentWindow().close();

                    cleverapps.focusManager.display({
                        focus: "UnitsLibraryWindow",
                        stack: true,
                        action: function (f) {
                            new UnitsLibraryWindow(this.unit);
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }.bind(this)
                    });
                }.bind(this)
            });
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    UNITICON_TITLE: {
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    UNITICON_LEVEL: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.UnitLibraryIcon = {
    margin: 0,

    footer: true,

    background: {
        width: 260,
        height: 340
    },

    producer: {
        x: { align: "left", dx: 10 },
        y: { align: "bottom", dy: 15 },
        width: 80,
        height: 80
    }
};
